<template>
  <div class="v-tabs">
    <ul class="tabs">
      <li
        v-for="(item, key) in options"
        :key="key"
        @click="changeTab(item.value)"
        :class="{ current: item.value === currValue }"
        class="d-f jc-c ai-c"
      >
        <span>
          {{ item.label }}
          <em v-if="item.tag" class="num d-f jc-c ai-c">{{ item.tag }}</em>
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import { create } from '../utils'

export default create({
  name: 'tabs',
  props: {
    value: {
      type: String
    },
    options: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      currValue: this.value
    }
  },
  methods: {
    changeTab(value) {
      this.currValue = value
      this.$emit('input', this.currValue)
    }
  }
})
</script>

<style lang="scss">
.v-tabs {
  .tabs {
    position: relative;
    width: 100%;
    height: 156px;
    display: flex;

    li {
      flex: 1;
      flex-shrink: 0;
      font-size: 45px;
      text-align: center;
      color: #b2b2b2;
      @include os-font-weight(45, 40);

      span {
        position: relative;
        .num {
          position: absolute;
          // 样式改版
          left: 95%;
          top: -24px;
          z-index: 3;
          padding: 2px 15px 0 15px;
          min-width: 48px;
          height: 48px;
          line-height: 52px;
          border-radius: 24px;
          background: #f10313;
          color: $white;
          text-align: center;
          font-size: 30px;
          @include os-font-weight-number(30, 50);
          box-sizing: border-box;
        }
      }

      &.current {
        color: #e90f23;
        @include os-font-weight(45, 40);
        span {
          border-bottom: 21px solid #e90f23;
          line-height: 53px;
          padding-bottom: 3px;
        }
      }
    }
  }
}
</style>
